import { Appointment } from "@/features/appointments/types/Appointment";
import { useHealthAssessment } from "@/features/health-assessment/hooks/useHealthAssessment";
import { useIsMetabolicUser } from "@/features/metabolic-health/hooks/useMetabolicHealth";
import { useGetDocuments } from "@/features/ocr/hooks/useGetDocuments";
import { useConsultsStore } from "@/utils/stores/useConsultsStore";
import { ExpertRole } from "../types/ExpertRole";

export const useNutritionistConsult = (): { shouldPushNutritionistBooking: boolean; hasFutureNutritionistAppointment: boolean, bookNutriAvailable: boolean, nutriConsultsLeft: Appointment[], lastNutritionistConsult: Appointment } => {
    const { consultsData } = useConsultsStore();
    const futureNutritionistConsults = consultsData?.nutritionistFutureConsults || [];
    const pastConsults = consultsData?.allPastAppointments || [];
    const nutriConsultsLeft = consultsData.nutritionistFutureConsults || [];

    const { isHealthAssessmentCompleted } = useHealthAssessment()
    const healthAssessmentCompleted = isHealthAssessmentCompleted()
    const { data: documents } = useGetDocuments();
    const filesUploaded = documents !== undefined && documents.length !== 0
    const isMetabolicUser = useIsMetabolicUser()

    const hasFutureNutritionistAppointment = futureNutritionistConsults.length > 0;

    const sortedPastConsults = pastConsults
        .filter(consult => consult.expert.role === ExpertRole.Nutritionist)
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

    const sortedSpecialistPastConsults = pastConsults
        .filter(consult => (consult.expert.role === ExpertRole.Specialist || consult.expert.role === ExpertRole.Physician))
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

    const lastNutritionistConsult = sortedPastConsults[0];
    const lastSpecialistConsult = sortedSpecialistPastConsults[0];

    const lastConsultWithin25Days = lastNutritionistConsult && lastNutritionistConsult.remainingDays >= -25;

    const shouldPushNutritionistBooking = !hasFutureNutritionistAppointment && !lastConsultWithin25Days;

    const bookNutriAvailable = !isMetabolicUser ? true : (healthAssessmentCompleted && filesUploaded && lastSpecialistConsult?.remainingMinutes < 0);

    return { shouldPushNutritionistBooking, hasFutureNutritionistAppointment, bookNutriAvailable, nutriConsultsLeft, lastNutritionistConsult }
}